<template>
    <div class="third-column" :style="rightStyle" :class="{'mobile-tc': isMobile}">
        <div class="third-column-content" :class="{innerRightClass }" id="info-sidebar">
            <button class="btn btn-success" @click="hideAction()">CLOSE POP UP</button><!-- TODO: A nice close button for mobile and a different one for desktop -->
        </div>
    </div>
</template>
<script>
export default {
    props: {
        isMobile: {
            required: true,
            type: Boolean
        },
    },

    data() {
        return {
            rightStyle: "max-width:0rem;",
            innerRightClass: "third-column-inner-hidden",
        };
    },

    watch: {
        isMobile(isMobile) {
            if(isMobile) {
                this.adaptToMobile();
            } else {
                this.adaptToFull();
            }
        },

        infoSidebarOpenStatus(value) {
            if (value) {
                this.show();
            } else {
                this.hide();
            }
        },
    },

    computed: {
        infoSidebarOpenStatus() {
            return this.$sidebar('isOpen');
        },
    },

    methods: {
        adaptToMobile() {
            this.placeholderClass = "placeholder-collapsed";
            this.sidebarClass= "menu-closed";
        },

        adaptToFull() {
            this.innerRightClass="third-column-inner-hidden";
            this.rightStyle="max-width:0rem;";
        },

        show() {
            if(this.isMobile) {
                //pop up right panel
                this.rightStyle="max-width:95vw; visibility:visible; opacity:1; transform:translateY(0px);";
            } else {
                //open right panel
                this.rightStyle="max-width:16rem; opacity:1;visibility:visible;";
                setTimeout(()=>{
                    this.innerRightClass="third-column-inner";
                },200);
            }
        },

        hide() {
            if(this.isMobile) {
                //close pop up
                this.rightStyle="max-width:95vw; visibility:hidden; opacity:0; transform:translateY(-100px);";
            } else {
                //close right panel

                this.innerRightClass="third-column-inner-hidden";
                setTimeout(()=>{
                    this.rightStyle="max-width:0rem; opacity:0;visibility:none;";
                },200);
            }
        },

        hideAction() {
            this.$sidebar('hide');
        }
    }
}
</script>